export const jestFix = (callback: () => any): any => {
	return callback && callback()
}
